var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import { classNames } from '../../utils/cn';
var cls = classNames('banner-layout');
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { ResponsiveContainer } from '../elements/responsive-container';
import { Image } from '../elements/image';
export var BannerLayoutDefaultProps = {}; // -------- Child Component Props -------->
// -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var ImageStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DescriptionStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
}); // -------- Components -------->

var My = {
  Container: styled(ResponsiveContainer)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Image: styled(Image)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Title: styled.h1.attrs(cls.attr('title'))(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Description: styled.div.attrs(cls.attr('description'))(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
export var BannerLayout = function BannerLayout(props) {
  var className = props.className,
      entity = props.entity;
  var image = entity.image2x || entity.image;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Image, {
    image: image
  }));
};
BannerLayout.defaultProps = BannerLayoutDefaultProps;
BannerLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;